/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Region } from '@generated/api'
import { EventType } from '@shared/lib/gtm/baseFunctions'
import { translit } from '@shared/lib/gtm/translit'

class StatDataLoader {
  private data: EventType = {}

  private resolveReady

  private queue = []

  private ready = new Promise<boolean>((resolve) => {
    this.resolveReady = resolve
  })

  constructor() {
    this.ready.finally(() => {
      this.dequeue()
    })
  }

  // updateProfileData() {
  //   this.data.userAuth = Number(authHelper.isAuthenticated())

  //   return new Promise((resolve) => {
  //     authHelper.ready.finally(() => {
  //       if (authHelper.userProfile) {
  //         this.data.numberType = authHelper.userProfile.type
  //         this.data.accountType = authHelper.userProfile.accountType
  //       }
  //       resolve(true)
  //     })
  //   })
  // }

  setRegion(selectedRegion: Region) {
    // @ts-ignore
    this.data.region = translit(selectedRegion.regionName)
    // @ts-ignore
    this.data.regionId = selectedRegion.regionCentreCode
  }

  dequeue() {
    this.queue.forEach((fn: (data: EventType) => void, index: number, arr) => {
      if (typeof fn === 'function') {
        fn({
          ...this.data,
          // timeStamp: new Date().getTime(),
        })
      }
      arr.splice(index, 1)
    })
  }

  push(fn) {
    this.queue.push(fn as never)
    this.ready.finally(() => {
      this.dequeue()
    })
  }
}

const statDataLoader = new StatDataLoader()

export { statDataLoader }
